import * as React from "react"
import { Loader2 } from "lucide-react"

import { cn } from "@/lib/utils"

interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "default" | "lg"
}

const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
  ({ className, size = "default", ...props }, ref) => {
    const sizeClasses = {
      sm: "h-4 w-4",
      default: "h-6 w-6",
      lg: "h-8 w-8",
    }

    return (
      <div ref={ref} className={cn("animate-spin", className)} {...props}>
        <Loader2 className={cn(sizeClasses[size], "text-muted-foreground")} />
      </div>
    )
  }
)
Spinner.displayName = "Spinner"

interface LoadingOverlayProps extends React.HTMLAttributes<HTMLDivElement> {
  text?: string
}

const LoadingOverlay = React.forwardRef<HTMLDivElement, LoadingOverlayProps>(
  ({ className, text = "Loading...", ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "flex h-full w-full items-center justify-center py-12",
        className
      )}
      {...props}
    >
      <div className="flex flex-col items-center gap-2">
        <Spinner size="lg" />
        <p className="text-sm text-muted-foreground">{text}</p>
      </div>
    </div>
  )
)
LoadingOverlay.displayName = "LoadingOverlay"

export { Spinner, LoadingOverlay }
